import React, { useEffect, useState } from "react";
import CustomTabs from "../../../../Custom/CustomTabs";
import PropertyInfo from "./InfoCollectionStep/PropertyInfo";
import AttachDocuments from "./InfoCollectionStep/AttachDocuments";
import AssignAdvocate from "./InfoCollectionStep/AssignAdvocate";
import AssignFrontendTeam from "./InfoCollectionStep/AssignFrontendTeam";
import { MdChevronRight } from "react-icons/md";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../../components/Constant/Notification";
import { userUid } from "../../../../../utils/storage";
import ProspectPropertyService from "../../../../Service/ProspectPropertyService";
import { ToastContainer } from "react-toastify";
import ConfirmationModal from "../../../../../components/shareableContainer/ConfirmationModal";
const InfoCallectionPage = ({ propertyId, setCurrentStep , isDropped , setProgressTrigger }) => {
  const [currentTab, setCurrentTab] = useState(1);
  const [selectedUsersData, setSelectedUsersData] = useState({});
  const [isConfirmed, setIsConfirmed] = useState(false);

  const tabs = [
    // { id: 1, name: "Fill Property Info" },
    // { id: 2, name: "Attach Documents" },
    { id: 1, name: "Assign Advocate" },
    { id: 2, name: "Assign Front end Team" },
  ];

  const [propertyData, setPropertyData] = useState(null);
  const [selectedFrontendUser, setSelectedFrontendUser] = useState(
    [] || propertyData?.assignedFrontendTo?.value || []
  );


  const fetchStageWiseData = async() => {
   try{
    const response = await ProspectPropertyService.getStageWiseProperties({
      propertyId : propertyId,
      stage : "Info Collection & Assignment"
    })
    const data = response.data?.data;
  
    if(data){
      setPropertyData(data)

    }
   }catch(error){
    console.error("Error fetching stage wise data:", error);
   }
  }

  useEffect(() => {
   
    fetchStageWiseData()
  }, [propertyId])

  const handleMoveToNextStage = async () => {
    if (currentTab !== 2) {
      return;
    }

    try {
      const body = {
        propertyId: propertyId,
        modifiedById: userUid,
        frontendTeamObj: {
          advocateLegalAnalysisUser:
            selectedUsersData?.advocateLegalAnalysis?.id,
          vaoLegalAnalysisUser: selectedUsersData?.vaoLegalAnalysis?.id,
          sroLegalAnalysisUser: selectedUsersData?.sroLegalAnalysis?.id,
          physicalInspectionUser: selectedUsersData?.physicalInspection?.id,
        },
      };
      const response =
        await ProspectPropertyService.updateFrontendUserAssignment(body);

      if (response.status === 200 || response.status === 201) {
        showSuccessToast(
          response.data.message || "Moved to next stage successfully"
        );
        setProgressTrigger((prev) => !prev); // trigger progress refetch
        setCurrentStep(2);
      }
    } catch (error) {
      console.error("Error moving to next stage:", error);
      showErrorToast(
        error.response?.data?.message || "Error moving to next stage"
      );
    }
  };

  const handleSelectedUsersChange = (users) => {
    setSelectedUsersData(users);
  };

  return (
    <div className="bg-white rounded-[10px] p-6 h-[700px]">
      <ToastContainer />
      <div className="flex items-end justify-end mb-4">
        <button
          onClick={() => {
            
            if (currentTab === 2 && !isDropped) {
              if (
                !selectedUsersData?.advocateLegalAnalysis ||
                !selectedUsersData?.vaoLegalAnalysis ||
                !selectedUsersData?.sroLegalAnalysis ||
                !selectedUsersData?.physicalInspection
              ) {
                showErrorToast(
                  "Please assign all front end team members before moving to next stage"
                );
                return;
              }
              setIsConfirmed(true);
            }
          }}
          className={`${
            currentTab === 2 && !isDropped
              ? "cursor-pointer text-white bg-customGreen"
              : "cursor-default bg-gray-400 text-white"
          } flex items-center rounded-full px-3 py-2  gap-2`}
        >
          <div className="text-sm"> Move to Next Stage </div>
          <MdChevronRight className="text-2xl" />
        </button>
      </div>
      <div className="w-1/2">
        <CustomTabs
          tabs={tabs}
          currentTab={currentTab}
          onTabChange={setCurrentTab}
        />
      </div>

      {/* 
      {currentTab === 1 && (
        <div className="py-5">
          <PropertyInfo propertyId={propertyId} setCurrentTab={setCurrentTab} setPropertyData={setPropertyData} />
        </div>
      )}

      {currentTab === 2 && (
        <div className="py-5">
          <AttachDocuments propertyId={propertyId} setCurrentTab={setCurrentTab} setPropertyData={setPropertyData} propertyData={propertyData} />
        </div>
      )} */}

      {currentTab === 1 && (
        <div className="py-5">
          <AssignAdvocate
            propertyId={propertyId}
            setCurrentTab={setCurrentTab}
            setPropertyData={setPropertyData}
            propertyData={propertyData}
            isDropped={isDropped}
            onDataUpdate={fetchStageWiseData}
          />
        </div>
      )}

      {currentTab === 2 && (
        <div className="py-5">
          <AssignFrontendTeam
            setSelectedFrontendUser={setSelectedFrontendUser}
            selectedFrontendUser={selectedFrontendUser}
            propertyData={propertyData}
            onSelectedUsersChange={handleSelectedUsersChange}
            isDropped={isDropped}
            onDataUpdate={fetchStageWiseData}
          />
        </div>
      )}

      <ConfirmationModal
        showModal={isConfirmed}
        title="Confirm Move to Next Stage"
        message="Are you sure you want to move to the next stage? This action cannot be undone."
        onConfirm={handleMoveToNextStage}
        onCancel={() => {
          setIsConfirmed(false);
        }}
      />
    </div>
  );
};

export default InfoCallectionPage;
